import { a as __makeTemplateObject, c as __rest, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { m as medium } from './breakpoints-70e05b67.js';
import { T as Tooltip } from './Tooltip-fbba5f7f.js';

var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgInfoTooltip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-class": "Icon-stroke",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#6273C9",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M9.5 8.5v7.071M9.5 4.5v1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5
  }))));
}

var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 24px;\n  margin: 0 0 0 7px;\n  outline: none;\n  padding: 0;\n  position: relative;\n  vertical-align: top;\n  width: 21px;\n  z-index: 2;\n"], ["\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 24px;\n  margin: 0 0 0 7px;\n  outline: none;\n  padding: 0;\n  position: relative;\n  vertical-align: top;\n  width: 21px;\n  z-index: 2;\n"])));
var TooltipContents = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  width: 240px;\n\n  ", "\n\n  ", "\n"], ["\n  margin: 0;\n  padding: 0;\n  width: 240px;\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    color: " + theme.topForegroundPrimary + ";\n\n    a {\n      color: " + theme.topForegroundPrimary + ";\n      font-weight: bold;\n      text-decoration: none;\n    }\n  ";
}, medium(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 300px;\n  "], ["\n    width: 300px;\n  "]))));
var Icon = styled(SvgInfoTooltip)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    [data-svg-class=\"Icon-stroke\"] {\n      stroke: " + theme.infoTooltipStrokeColor + ";\n    }\n  ";
});
var StyledTooltip = styled(Tooltip)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    background-color: " + theme.topBackgroundColor + ";\n    border-color: " + theme.topForegroundPrimary + ";\n    transition-duration: " + theme.transitionDurationPrimary + ";\n  ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

var InfoTooltip = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var buttonRef = useRef(null);
    var _b = useState(false), isVisible = _b[0], setIsVisible = _b[1];
    var handleClick = function () {
        setIsVisible(true);
    };
    var handleClose = function () {
        setIsVisible(false);
    };
    return (jsxs(Fragment, { children: [jsx(Container, __assign({ onClick: handleClick, ref: buttonRef, type: "button" }, { children: jsx(Icon, {}, void 0) }), void 0), jsx(StyledTooltip, __assign({ isVisible: isVisible, onClose: handleClose, position: "top", targetRef: buttonRef.current }, props, { children: jsx(TooltipContents, { children: children }, void 0) }), void 0)] }, void 0));
};

export { InfoTooltip as I };
